import React from 'react';
import { withRouter, NavLink } from 'react-router-dom';
import { withApollo } from "react-apollo";

import { registerToken } from '../../util';
import { requestMagic, loginMagic } from '../../graphql/mutations';



class Checkin extends React.Component {

	constructor(props) {
		super(props);

		this.state = {
			isSend: false,
			handle: ''
		};
	}
	
	componentDidMount() {
		
		const {token, handle} = this.props.match.params;

		if(handle) {
            this.setState({ handle });
        } else if(token) {
			this.props.client.mutate({
				mutation: loginMagic,
				variables: {
					token: token
				}
			})
			.then((response) => {

				if(response.data.loginMagic) {
					localStorage.setItem('token', response.data.loginMagic);					
					registerToken(this.props.client);
					this.props.history.push(`/`);
				}
			})
			.catch(e => {
				alert('Magic Login Error: ' + e);
			});
		}
	}


	mutate = () => {

		if(this.state.handle.trim() === '') {
			alert("Bitte verrate mir deinen Nutzernamen oder deine E-Mail-Adresse.")
			return;
		}

		this.props.client.mutate({
			mutation: requestMagic,
			variables: {
				handle: this.state.handle
			}
		})
		.then((response) => {
			if(response.data.requestMagic) {
				this.setState({isSend: true});
			}
		})
		.catch(e => {
			alert('Magic Request Error: ' + e);
		});
	}
	
	render() {

		return (
			<div className="fullHeight">
				<div className="container">
					<div className="centered login" style={{textAlign: 'center'}}>
                        
						<p style={{textAlign: 'center'}}>
							<img src="/logo.svg" className="logo" alt="Dashnet Logo" />
						</p>
						
						{!this.state.isSend && (
							<form onSubmit={(e) => e.preventDefault()}>
								<div className="richtext dist-1">
									<h3>Login via e-mail</h3>
									<p>
										Hier kannst du einen Link zum Einloggen an deine E-Mail-Adresse anfordern.
									</p>
								</div>
								<input className="input" type="text" placeholder="username or e-mail-address"
                                    value={this.state.handle}
                                    onChange={e => this.setState({ handle: e.target.value })} 
                                    />
								
								<div className="button-wrap">
									<NavLink className="button button--secondary" to="/login">&lt; login</NavLink>
									<button onClick={this.mutate} className="button button--submit">request login</button>
								</div>
							</form>
						)}

						{this.state.isSend && (
							<React.Fragment>
								<div className="richtext dist-1">
									<p>
										Okay, ich habe eine Nachricht an die von dir angegebene E-Mail-Adresse gesendet.
									</p>
									<p>
										Dies kann wenige Minuten dauern. Prüfe auch deinen Spamfilter.
									</p>
									<p>
										Du kannst diesen Tab jetzt schließen.
									</p>
								</div>
							</React.Fragment>
						)}
					</div>
				</div>
			</div>
		);
	}
}

export default withRouter(withApollo(Checkin))


// WEBPACK FOOTER //
// ./src/components/user/Checkin.js